import { DocumentsListItem, DocumentsListResponse } from "@/models/api/documents/DocumentsList";

export default {
  page: 1,
  items: [
    {
      id: "01097766-8638-40bd-955a-fa9839bffedf",
      documentTypeId: 1,
      orderId: "854623fb-d865-42f6-8756-945a632546ae",
      documentNumber: "42/02/2021/RZE",
      contractor: "Why Not Fly Sp. z o.o.",
      seller: "Why Not Fly Sp. z o.o.",
      tin: "8133577984",
      currency: "PLN",
      issueDate: "2021-02-10T00:00:00",
      saleDate: "2021-02-09T00:00:00",
      gross: 52976.78,
      grossInCurrency: 52976.78,
      leftToPay: 52976.78,
      leftToPayInCurrency: 52976.78,
      createdAt: "2021-02-10T03:10:09.077",
      recordStampId: 7902241,
      contractorId: 1478711,
      canEdit: true,
      isLockedForEditByOneOur: false,
      payments: null,
      isCancelled: false,
      formOfPaymentName: null,
      stateToSend: 20,
      copyCount: 0,
      canIssueDuplicateDocument: true,
      isDuplicate: false,
      delayPaymentDays: "-30",
    },
    {
      id: "a24881a5-26a4-42ed-9fdc-b17e04ecdb5d",
      documentTypeId: 1,
      orderId: "a893ec2c-f419-4359-a0c8-fe40eb5aff56",
      documentNumber: "41/02/2021/RZE",
      contractor: "Why Not Fly Sp. z o.o.",
      seller: "POLSKIE LINIE LOTNICZE LOT S.A.",
      tin: "8133577984",
      currency: "PLN",
      issueDate: "2021-02-10T00:00:00",
      saleDate: "2021-02-09T00:00:00",
      gross: 26528.13,
      grossInCurrency: 26528.13,
      leftToPay: 26528.13,
      leftToPayInCurrency: 26528.13,
      createdAt: "2021-02-10T03:10:05.97",
      recordStampId: 7902238,
      contractorId: 1478704,
      canEdit: true,
      isLockedForEditByOneOur: false,
      payments: null,
      isCancelled: false,
      formOfPaymentName: null,
      stateToSend: 20,
      copyCount: 0,
      canIssueDuplicateDocument: true,
      isDuplicate: false,
      delayPaymentDays: "-30",
    },
    {
      id: "a51e033d-2f2a-49c2-99ac-cff066d290c6",
      documentTypeId: 1,
      orderId: "039592ca-2b31-4836-ba1e-aa2ce7beedf2",
      documentNumber: "40/02/2021/RZE",
      contractor: "P.P.H.U Awex Rafał Stanuch",
      seller: "",
      tin: "7342620614",
      currency: "PLN",
      issueDate: "2021-02-10T00:00:00",
      saleDate: "2021-02-09T00:00:00",
      gross: 10293.86,
      grossInCurrency: 10293.86,
      leftToPay: 10293.86,
      leftToPayInCurrency: 10293.86,
      createdAt: "2021-02-10T01:00:08.33",
      recordStampId: 7902235,
      contractorId: 1478720,
      canEdit: true,
      isLockedForEditByOneOur: false,
      payments: null,
      isCancelled: false,
      formOfPaymentName: null,
      stateToSend: 20,
      copyCount: 0,
      canIssueDuplicateDocument: true,
      isDuplicate: false,
      delayPaymentDays: "-30",
    },
    {
      id: "f99d0805-5e2f-42b0-a8f0-1760a43f1bff",
      documentTypeId: 1,
      orderId: "38962909-c692-44b7-8d72-b5cce7525d4d",
      documentNumber: "39/02/2021/RZE",
      contractor: "Centrum Rozliczeń Elektronicznych Polskie ePłatności S.A.",
      seller: "",
      tin: "8133611149",
      currency: "PLN",
      issueDate: "2021-02-10T00:00:00",
      saleDate: "2021-02-09T00:00:00",
      gross: 791.57,
      grossInCurrency: 791.57,
      leftToPay: 791.57,
      leftToPayInCurrency: 791.57,
      createdAt: "2021-02-10T01:00:07.627",
      recordStampId: 7902232,
      contractorId: 1478708,
      canEdit: true,
      isLockedForEditByOneOur: false,
      payments: null,
      isCancelled: false,
      formOfPaymentName: null,
      stateToSend: 20,
      copyCount: 0,
      canIssueDuplicateDocument: true,
      isDuplicate: false,
      delayPaymentDays: "-7",
    },
    {
      id: "f994c5fe-6fcf-4181-8542-f147dd4c0c81",
      documentTypeId: 1,
      orderId: "e9427b78-432d-43c2-bac7-aad6b1b06878",
      documentNumber: "38/02/2021/RZE",
      contractor: "Centrum Rozliczeń Elektronicznych Polskie ePłatności S.A.",
      seller: "",
      tin: "8133611149",
      currency: "PLN",
      issueDate: "2021-02-10T00:00:00",
      saleDate: "2021-02-09T00:00:00",
      gross: 791.57,
      grossInCurrency: 791.57,
      leftToPay: 791.57,
      leftToPayInCurrency: 791.57,
      createdAt: "2021-02-10T01:00:06.32",
      recordStampId: 7902229,
      contractorId: 1478705,
      canEdit: true,
      isLockedForEditByOneOur: false,
      payments: null,
      isCancelled: false,
      formOfPaymentName: null,
      stateToSend: 20,
      copyCount: 0,
      canIssueDuplicateDocument: true,
      isDuplicate: false,
      delayPaymentDays: "-7",
    },
    {
      id: "7553e26a-6263-49ed-82e2-0f1efece71c9",
      documentTypeId: 1,
      orderId: "bbcc6da5-620d-4e3e-a41e-4f688c2bc27a",
      documentNumber: "37/02/2021/RZE",
      contractor: "FUNDACJA ROZWOJU TERAPII RODZIN NA SZLAKU",
      seller: "",
      tin: "6762453269",
      currency: "PLN",
      issueDate: "2021-02-09T00:00:00",
      saleDate: "2021-01-18T00:00:00",
      gross: 484.36,
      grossInCurrency: 484.36,
      leftToPay: 484.36,
      leftToPayInCurrency: 484.36,
      createdAt: "2021-02-09T14:17:25.197",
      recordStampId: 7902128,
      contractorId: 1478737,
      canEdit: true,
      isLockedForEditByOneOur: false,
      payments: null,
      isCancelled: false,
      formOfPaymentName: null,
      stateToSend: 20,
      copyCount: 0,
      canIssueDuplicateDocument: true,
      isDuplicate: false,
      delayPaymentDays: "1",
    },
    {
      id: "9518a7b5-e24f-40b2-bac7-9b970843751f",
      documentTypeId: 1,
      orderId: "0be6c52d-c619-4528-b18b-9ff76f07dff9",
      documentNumber: "36/02/2021/RZE",
      contractor: '"BLUE SKY TRAVEL" SPÓŁKA Z OGRANICZONĄ ODPOWIEDZIALNOŚCIĄ',
      seller: "",
      tin: "7811699670",
      currency: "PLN",
      issueDate: "2021-02-09T00:00:00",
      saleDate: "2021-01-18T00:00:00",
      gross: 484.36,
      grossInCurrency: 484.36,
      leftToPay: 484.36,
      leftToPayInCurrency: 484.36,
      createdAt: "2021-02-09T14:15:14.277",
      recordStampId: 7902123,
      contractorId: 1478736,
      canEdit: true,
      isLockedForEditByOneOur: false,
      payments: null,
      isCancelled: false,
      formOfPaymentName: null,
      stateToSend: 20,
      copyCount: 0,
      canIssueDuplicateDocument: true,
      isDuplicate: false,
      delayPaymentDays: "-59",
    },
    {
      id: "12ba82d2-0d43-457a-a333-164462fef556",
      documentTypeId: 1,
      orderId: "c901dc80-4e63-4836-a080-47a74239ee6e",
      documentNumber: "35/02/2021/RZE",
      contractor: '"BLUE SKY TRAVEL" SPÓŁKA Z OGRANICZONĄ ODPOWIEDZIALNOŚCIĄ',
      seller: "",
      tin: "7811699670",
      currency: "PLN",
      issueDate: "2021-02-09T00:00:00",
      saleDate: "2021-01-18T00:00:00",
      gross: 484.36,
      grossInCurrency: 484.36,
      leftToPay: 0,
      leftToPayInCurrency: 0,
      createdAt: "2021-02-09T14:08:42.73",
      recordStampId: 7902117,
      contractorId: 1478735,
      canEdit: true,
      isLockedForEditByOneOur: false,
      payments: null,
      isCancelled: false,
      formOfPaymentName: null,
      stateToSend: 20,
      copyCount: 0,
      canIssueDuplicateDocument: true,
      isDuplicate: false,
      delayPaymentDays: "-",
    },
    {
      id: "339071d2-ac9d-4c19-afe0-7b9eeeaa74cb",
      documentTypeId: 1,
      orderId: "518ad659-f4be-49dc-9e8c-ea384098f7f0",
      documentNumber: "34/02/2021/RZE",
      contractor: "Why Not Fly Sp. z o.o.",
      seller: "POLSKIE LINIE LOTNICZE LOT S.A.",
      tin: "8133577984",
      currency: "PLN",
      issueDate: "2021-02-09T00:00:00",
      saleDate: "2021-02-08T00:00:00",
      gross: 8260.25,
      grossInCurrency: 8260.25,
      leftToPay: 8260.25,
      leftToPayInCurrency: 8260.25,
      createdAt: "2021-02-09T03:10:15",
      recordStampId: 7901955,
      contractorId: 1478672,
      canEdit: true,
      isLockedForEditByOneOur: false,
      payments: null,
      isCancelled: false,
      formOfPaymentName: null,
      stateToSend: 20,
      copyCount: 0,
      canIssueDuplicateDocument: true,
      isDuplicate: false,
      delayPaymentDays: "-29",
    },
    {
      id: "f173b584-6903-4298-8c69-123920687121",
      documentTypeId: 1,
      orderId: "504c699a-194f-4690-a1c0-3e4c7f4b31ed",
      documentNumber: "33/02/2021/RZE",
      contractor: "Why Not Fly Sp. z o.o.",
      seller: "Why Not Fly Sp. z o.o.",
      tin: "8133577984",
      currency: "PLN",
      issueDate: "2021-02-09T00:00:00",
      saleDate: "2021-02-08T00:00:00",
      gross: 54699.39,
      grossInCurrency: 54699.39,
      leftToPay: 54699.39,
      leftToPayInCurrency: 54699.39,
      createdAt: "2021-02-09T03:10:08.06",
      recordStampId: 7901952,
      contractorId: 1478669,
      canEdit: true,
      isLockedForEditByOneOur: false,
      payments: null,
      isCancelled: false,
      formOfPaymentName: null,
      stateToSend: 20,
      copyCount: 0,
      canIssueDuplicateDocument: true,
      isDuplicate: false,
      delayPaymentDays: "-29",
    },
  ] as Array<DocumentsListItem>,
  totalCount: 185,
} as DocumentsListResponse;
